import React from 'react';

import {
    PushNotificationRemoveChangeRequest,
} from 'src/components/remove-change-request/push-notification-remove-change-request';
import {ChangeRequest} from 'src/openapi/models/ChangeRequest';

import {Button} from '@pb/kit-component-button';
import {Icons, Sizes} from '@pb/kit-component-icon';
import {BasicIconButton} from '@pb/kit-component-icon-button';
import {usePushNotification} from '@pb/kit-component-push-notification';

export enum BUTTON_TYPE {
    ICON = 'ICON',
    BUTTON = 'BUTTON',
}

type RemoveButtonType = BUTTON_TYPE.BUTTON | BUTTON_TYPE.ICON;

type Props = {
    changeRequest: ChangeRequest,
    buttonType: RemoveButtonType,
};

export const RemoveChangeRequest = ({changeRequest, buttonType}: Props) => {
    const {onCreateNote, onCloseNote} = usePushNotification();

    const onRemove = () => {
        if (!changeRequest.id) {
            return;
        }
        onCreateNote({
            id: `${changeRequest.id}`,
            body: () => (
                <PushNotificationRemoveChangeRequest
                    {...{
                        id: changeRequest.id || 0,
                        code: changeRequest.event.code,
                        source: changeRequest.event.source,
                        onClose: onCloseNote,
                    }}
                />
            ),
            buttonProps: {icon: Icons.CLOSE},
            autoHideTimeout: 10000,
        });
    };

    return buttonType === BUTTON_TYPE.ICON ?
            <BasicIconButton iconProps={{type: Icons.TRASH_LIGHT, size: Sizes.Size_14}} onClick={onRemove}/> :
            <Button colorVariant="ERROR" onClick={onRemove} variant="Type.SECONDARY">Delete</Button>;
};
